export default "__VITE_ASSET__BaMaphUh__"